import React from "react";
import { Link } from "react-router-dom";
import FireLogo from "../components/FireLogo";
import Footer from "../components/Footer";

export default function ProjectGoals() {
  return (
    <div className="min-h-screen bg-[var(--bg)] text-[var(--ink)]">
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 hero-gradient" />
        <div
          className="absolute -top-24 left-10 h-60 w-60 rounded-full opacity-40 blur-3xl animate-float"
          style={{ backgroundColor: "var(--accent-3)" }}
        />
        <div
          className="absolute top-10 right-10 h-72 w-72 rounded-full opacity-25 blur-3xl animate-float-slow"
          style={{ backgroundColor: "var(--accent-2)" }}
        />
        <div className="hero-container relative mx-auto max-w-6xl px-4 pb-12 pt-12">
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="inline-flex items-center gap-3 rounded-full bg-white/70 px-3 py-1 text-xs uppercase tracking-[0.2em] text-[var(--muted)]">
              <FireLogo size={40} data-hero-logo />
              <span>BetterBMRCalculator</span>
            </div>
            <div className="flex flex-wrap items-center gap-3">
              <Link
                to="/"
                className="inline-flex items-center justify-center rounded-full border border-white/70 bg-white/80 px-5 py-2 text-xs font-semibold text-[var(--ink)] transition hover:-translate-y-0.5 hover:shadow-lg"
              >
                Back to calculator
              </Link>
              <Link
                to="/donate"
                className="inline-flex items-center justify-center rounded-full bg-[var(--accent)] px-5 py-2 text-xs font-semibold text-white shadow-[0_18px_40px_rgba(227,108,79,0.35)] transition hover:-translate-y-0.5"
              >
                Support the project
              </Link>
            </div>
          </div>
          <div className="mt-6 max-w-3xl space-y-4">
            <h1 className="text-3xl font-display leading-tight text-[var(--ink)] md:text-4xl">
              Project goals
            </h1>
            <p className="text-base text-[var(--muted)]">
              Hi, I&apos;m Maxwell McInnis. I&apos;m a 23-year-old Canadian, 
              a new engineering graduate starting in the workplace. I had my
              own excel sheet version of this to try to find out what I need 
              to eat, but this is a lot more conveinient. So I'm making it
              available to everyone.
            </p>
          </div>
        </div>
      </div>

      <section className="mx-auto max-w-6xl px-4 pb-16">
        <div className="glass-card p-6 md:p-8">
          <h2 className="text-2xl font-display text-[var(--ink)]">
            Why this exists
          </h2>
          <p className="mt-3 text-sm text-[var(--muted)]">
            Current calculators don&apos;t account for real training volume.
            A &quot;very active&quot; person might be doing 1–2 hours per day,
            or they might be doing 6 hours. Those are completely different
            energy needs. Someone could think they should eat 3,000 calories
            when they actually need 5,000. That gap can cause eating-related
            health issues, hormone problems, and a lot of confusion without
            real data.
          </p>
          <p className="mt-3 text-sm text-[var(--muted)]">
            As a young fitness enthusiast, I&apos;ve had to go against common
            health recommendations just to stay healthy and keep hormones
            stable—because there was no practical way to calculate what I
            actually needed.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 pb-16">
        <div className="glass-card p-6 md:p-8">
          <h2 className="text-2xl font-display text-[var(--ink)]">
            What I&apos;m building
          </h2>
          <ul className="mt-4 grid gap-3 text-sm text-[var(--muted)] md:grid-cols-2">
            <li>
              Free access for everyone so people can avoid health
              complications.
            </li>
            <li>
              A clearer picture of real daily needs based on actual training
              detail.
            </li>
            <li>
              A place to suggest bug fixes and new features so the tool keeps
              improving.
            </li>
          </ul>
        </div>
      </section>

      <section className="mx-auto max-w-6xl px-4 pb-16">
        <div className="glass-card p-6 md:p-8">
          <h2 className="text-2xl font-display text-[var(--ink)]">
            Funding and roadmap
          </h2>
          <p className="mt-3 text-sm text-[var(--muted)]">
            With current features only, the yearly cost should be around
            <strong> $25</strong> for global access (mostly the domain). Donations
            cover that cost and give me the time to build more free features.
          </p>
          <p className="mt-3 text-sm text-[var(--muted)]">
            There are plans for a second, paid version that stores your
            information and tracks progress. That version will be paid because
            it depends on backend storage, compute, and AI services.
          </p>
          <div className="mt-4 flex flex-wrap items-center gap-3">
            <Link
              to="/donate"
              className="inline-flex items-center justify-center rounded-full bg-[var(--accent)] px-5 py-2 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(227,108,79,0.35)] transition hover:-translate-y-0.5"
            >
              Support the project
            </Link>
            <a
              href="https://www.linkedin.com/in/maxwellmcinnis"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center rounded-full border border-white/70 bg-white/80 px-5 py-2 text-sm font-semibold text-[var(--ink)] transition hover:-translate-y-0.5 hover:shadow-lg"
            >
              Contact me on LinkedIn
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
